export type AssetTag = {
  name: string
  color?: string
  id: number
}

export type TableTagsHeaderProps = {
  tags?: AssetTag[]
  selectedTagIds?: string[]
  onTagSelect?: (tagId: number) => void
  onTagsModalOpen?: () => void
  displayTags?: boolean
  shouldDisplay?: boolean
}

export enum ModalOpenVariant {
  ASSET = 'asset',
  FILTER = 'filter',
  ALERT = 'alert',
}
